'use client';

import { useTranslations } from 'next-intl';
import { BookCallTFComponentDiv } from 'components/home/BottomBar';
import { CustomImage } from 'components/shared/custom-image/CustomImage';
import { useModal } from 'components/shared/Modal';
import { ringProUsAsset } from '../ringProUsAsset';
import styles from './RingProUsTalk.module.css';

const photo = ringProUsAsset('talk/talk-expert.png');
const photoMobile = ringProUsAsset('talk/talk-mobile.png');

/**
 * "Talk to an expert." (Figma 2935:7787). Book a call opens the same Typeform
 * modal as the header's Talk to an expert.
 */
export const RingProUsTalk = () => {
  const t = useTranslations('homepage');
  const modal = useModal();

  const bookCall = () => {
    let url = 'website';
    if (typeof window !== 'undefined') {
      url = window.location.hostname + window.location.pathname;
    }
    modal.set(
      <BookCallTFComponentDiv
        trackingParams={{ utm_source: url, utm_medium: 'us-homepage-talk' }}
      />,
    );
    modal.setCloseButtonTheme('light');
    modal.show();
  };

  return (
    <section
      className={styles.section}
      aria-labelledby="ring-pro-us-talk-title"
    >
      <CustomImage
        className={`${styles.photo} ${styles.photoDesktop}`}
        src={photo}
        alt=""
        fill
        sizes="100vw"
        aria-hidden
      />
      <CustomImage
        className={`${styles.photo} ${styles.photoMobile}`}
        src={photoMobile}
        alt=""
        fill
        sizes="100vw"
        aria-hidden
      />
      <div className={styles.scrim} aria-hidden />
      <div className={styles.sideFade} aria-hidden />
      <div className={styles.edgeFade} aria-hidden />
      <div className={styles.copy}>
        <h2 id="ring-pro-us-talk-title" className={styles.title}>
          {t('homepage.ringProUs.talk.title')}
        </h2>
        <p className={styles.body}>{t('homepage.ringProUs.talk.body')}</p>
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.book}
            onClick={bookCall}
            data-buttontype="ring_pro_us_talk_book"
          >
            {t('homepage.ringProUs.talk.book')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default RingProUsTalk;
